import React, { useEffect, useState, useCallback } from 'react';
import { PS } from '../theme';
import { Icon } from '../lib/icons';
import { queueCount } from '../lib/offlineDb';
import { flushQueue } from '../lib/sync';

// Global online/offline + sync-status bar. Auto-flushes the queue on reconnect.
export default function OfflineBar() {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(0);
  const [syncing, setSyncing] = useState(false);

  const refresh = useCallback(async () => { setPending(await queueCount()); }, []);

  const doSync = useCallback(async () => {
    if (!navigator.onLine) return;
    setSyncing(true);
    await flushQueue();
    setSyncing(false);
    refresh();
  }, [refresh]);

  useEffect(() => {
    refresh();
    const onUp = () => { setOnline(true); doSync(); };
    const onDown = () => setOnline(false);
    window.addEventListener('online', onUp);
    window.addEventListener('offline', onDown);
    window.addEventListener('ps-queue-changed', refresh);
    if (navigator.onLine) doSync();
    return () => {
      window.removeEventListener('online', onUp);
      window.removeEventListener('offline', onDown);
      window.removeEventListener('ps-queue-changed', refresh);
    };
  }, [refresh, doSync]);

  if (online && pending === 0) return null;

  const offline = !online;
  const bg = offline ? PS.ink : PS.gold;
  const fg = offline ? PS.page : PS.ink;
  return (
    <div data-testid="offline-bar" style={{ position: 'fixed', top: 'max(8px, env(safe-area-inset-top))', left: '50%', transform: 'translateX(-50%)', zIndex: 2000, width: 'calc(100% - 24px)', maxWidth: 460 }}>
      <div className="ps-fade" style={{ background: bg, color: fg, borderRadius: 14, padding: '9px 14px', display: 'flex', alignItems: 'center', gap: 10, boxShadow: '0 6px 24px rgba(20,18,16,0.22)' }}>
        <div style={{ width: 8, height: 8, borderRadius: 4, background: offline ? PS.gold : PS.forest, flexShrink: 0 }} className={offline ? '' : 'ps-live-dot'} />
        <div style={{ flex: 1, fontSize: 12, fontWeight: 600, lineHeight: 1.35 }}>
          {offline
            ? `ออฟไลน์ · บันทึกจะเก็บในเครื่อง${pending > 0 ? ` (${pending} รอ sync)` : ''}`
            : syncing ? `กำลัง sync ${pending} รายการ…` : `มี ${pending} รายการรอ sync`}
        </div>
        {!offline && !syncing && (
          <button data-testid="offline-sync-btn" onClick={doSync} className="ps-press" style={{ flexShrink: 0, background: 'rgba(26,26,26,0.12)', color: fg, border: 'none', borderRadius: 9, padding: '5px 11px', fontSize: 11.5, fontWeight: 700, fontFamily: PS.fontUI, display: 'flex', alignItems: 'center', gap: 5 }}>
            <Icon.send size={12} stroke={fg} /> sync เลย
          </button>
        )}
      </div>
    </div>
  );
}
